const filmLocationRouter = {
  route: null,
  name: null,
  title: '影片承制',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-film',
  filePath: 'view/film_production/', // 文件路径
  order: 40,
  inNav: true,
  permission: ['承制方列表'],
  children: [
    {
      title: '承制方列表',
      type: 'view',
      name: 'filmProductionList',
      route: '/filmProduction/list',
      filePath: 'view/film_production/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['承制方列表'],
    },
    {
      title: '新增承制方',
      type: 'view',
      name: 'addFilmProduction',
      route: '/filmProduction/add',
      filePath: 'view/film_production/create.vue',
      inNav: true,
      icon: 'iconfont el-icon-document-add',
      permission: ['新增承制方'],
    },
  ],
}

export default filmLocationRouter
